export const receivementStatus = {
  WAITING_QUEUE: 'Fila',
  IN_ATTENDANCE: 'Em atendimento',
  RECEIVED: 'Recebido',
  DIVERGENCE_OPENED: 'Divergência aberta',
  DIVERGENCE_FINISHED: 'Divergência finalizada',
  SALES_APPROVAL_OPENED: 'Em aceite por compras',
  SALES_APPROVAL_FINISHED: 'Aceite de compras finalizado',
  IN_BARCODE_RESOLUTION: 'Em resolução de barcode',
  FAILED_WITH_EXTERNAL_SOURCES: 'Falha de integração',
  SENT_TO_DOCK: 'Enviado para a doca',
  CANCELED: 'Cancelado',
  FINISHED: 'Finalizado',
  PRE_QUEUE: 'Pré fila',
  WAITING_MANAGER_CONFERENCE: 'Aguardando conferência do gestor',
  WAITING_SEFAZ: 'Aguardando SEFAZ',
  MANAGER_CONFERENCE_FINISHED: 'Conferência do gestor finalizada',
  WAITING_TRUCK_DRIVER_CONFIRMATION: 'Aguardando confirmação do motorista',
  PROCESSING_TRUCK_DRIVER_CONFIRMATION: 'Processando confirmação do motorista',
  SENDING_INVOICES_TO_FINANCES: 'Enviando notas para o financeiro',
  PROCESSING_AFTER_OVERVIEW: 'Processando pós overview',
}

export const mapReceivementStatus = (status) => {
  const statusName = receivementStatus[status]

  return statusName ? statusName : 'Status desconhecido!'
}
